import FirstCyclePaid from '@/api/hr/first-cycle-paid'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  cycle_year: moment().format('YYYY'),
  cycle_month: moment().format('MM')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CYCLE_YEAR(state, cycle_year) {
    state.cycle_year = cycle_year
  },
  SET_CYCLE_MONTH(state, cycle_month) {
    state.cycle_month = cycle_month
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        cycle_year: context.state.cycle_year,
        cycle_month: context.state.cycle_month
      },
      attributes
    )
    return FirstCyclePaid.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  destroy(context, data) {
    return FirstCyclePaid.destroy(data)
  }
}
